module.exports = __webpack_public_path__ + "img/y_2010.b3993eda.png";